var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.message._status === 0)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),(_vm.message._status === 2)?_c('i',{staticClass:"el-icon-warning error",on:{"click":_vm.handleErrorClick}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }